module.exports = __webpack_public_path__ + "img/opened-icon.f3bddde1.webp";